var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 3.66634C10.833 1.82467 9.34134 0.333008 7.49967 0.333008C5.65801 0.333008 4.16634 1.82467 4.16634 3.66634C4.16634 5.50801 5.65801 6.99967 7.49967 6.99967C9.34134 6.99967 10.833 5.50801 10.833 3.66634ZM9.16634 3.66634C9.16634 4.58301 8.41634 5.33301 7.49967 5.33301C6.58301 5.33301 5.83301 4.58301 5.83301 3.66634C5.83301 2.74967 6.58301 1.99967 7.49967 1.99967C8.41634 1.99967 9.16634 2.74967 9.16634 3.66634ZM0.833008 11.9997V13.6663H14.1663V11.9997C14.1663 9.78301 9.72468 8.66634 7.49967 8.66634C5.27467 8.66634 0.833008 9.78301 0.833008 11.9997ZM2.49967 11.9997C2.66634 11.408 5.24967 10.333 7.49967 10.333C9.74134 10.333 12.3163 11.3997 12.4997 11.9997H2.49967ZM16.6663 9.49967V6.99967H19.1663V5.33301H16.6663V2.83301H14.9997V5.33301H12.4997V6.99967H14.9997V9.49967H16.6663Z",
    fill: "#1E88E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlusBlue);
export default __webpack_public_path__ + "static/media/user-plus-blue.95fe8eaf7d24f62bc27ec990db60b7ca.svg";
export { ForwardRef as ReactComponent };